import * as React from 'react';
import { Link } from 'react-router-dom';
import { TranslationFunction } from 'i18next';
import { Routes, makeSimpleRoutePath } from '../utils/routerHelper';

interface Props {
  sectionId: string;
  label: string;
  t: TranslationFunction;
  className?: string;
}

const AdminGuideLink: React.FC<Props> = ({ sectionId, label, t, className }) => (
  <Link
    to={`${makeSimpleRoutePath(Routes.AdminGuide, t)}#${sectionId}`}
    className={className || 'cc__admin_guide_link'}
  >
    {label}
  </Link>
);

export default AdminGuideLink;
